export const BONUS_INLINE_MAX_TEXT_FILES = 50;
export const BONUS_INLINE_MAX_TEXT_CHARS = 200_000;

export interface BonusInlineTextFileLike {
  fileName?: string;
  mimeType?: string;
  contents?: string;
}

function formatCount(value: number): string {
  return value.toLocaleString('en-US');
}

export const BONUS_INLINE_MAX_TEXT_LABEL = `${formatCount(BONUS_INLINE_MAX_TEXT_CHARS)} characters`;

export function sumBonusInlineTextChars(files: readonly BonusInlineTextFileLike[]): number {
  return files.reduce(
    (total, file) => total + (typeof file.contents === 'string' ? file.contents.length : 0),
    0
  );
}

export function validateBonusInlineTextFiles(
  files: readonly BonusInlineTextFileLike[]
): string | null {
  if (files.length > BONUS_INLINE_MAX_TEXT_FILES) {
    return `Add up to ${BONUS_INLINE_MAX_TEXT_FILES} lyric template files per pack.`;
  }

  let totalChars = 0;
  for (const file of files) {
    const fileName = typeof file.fileName === 'string' ? file.fileName.trim() : '';
    const mimeType = typeof file.mimeType === 'string' ? file.mimeType.trim() : '';
    const contents = typeof file.contents === 'string' ? file.contents : '';
    if (!fileName) {
      return 'Add the lyric template file name first.';
    }
    if (mimeType && mimeType !== 'text/plain') {
      return 'Lyric template files must be saved as plain text.';
    }
    const validation = validateBonusInlineTextFile(fileName, contents);
    if (validation) return validation;
    totalChars += contents.length;
    if (totalChars > BONUS_INLINE_MAX_TEXT_CHARS) {
      return `These lyric template files add up to ${formatCount(totalChars)} characters. The limit is ${BONUS_INLINE_MAX_TEXT_LABEL} per pack.`;
    }
  }

  return null;
}

export function validateBonusInlineTextFile(fileName: string, contents: string): string | null {
  if (!fileName.trim()) return 'Add the lyric template file name first.';
  if (contents.length > BONUS_INLINE_MAX_TEXT_CHARS) {
    return `That text file has ${formatCount(contents.length)} characters. The limit is ${BONUS_INLINE_MAX_TEXT_LABEL}.`;
  }
  return null;
}
